import api from '@/api';

export default {
  expandGroup: function (groupMailAddress: string): Promise<ExpandGroupResponse> {
    return api.get({
      url: `/cubelook/group/api/expand?group=${groupMailAddress}`,
    });
  },
};
